import * as Sentry from '@sentry/react';

/**
 * Inicializa Sentry si VITE_SENTRY_DSN está configurado.
 * Si no hay DSN, no-op (logs en consola).
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;
  Sentry.init({
    dsn,
    tracesSampleRate: 0.1,
    environment: import.meta.env.MODE,
  });
}

/** Captura un error manualmente (uso: ErrorBoundary.componentDidCatch). */
export function captureError(e: unknown, context?: Record<string, unknown>) {
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.captureException(e, { extra: context });
  } else {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', e, context);
  }
}